import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { LoginState } from './model/LoginState';
import { Component, ElementRef, OnInit } from '@angular/core';
import { AuthenticationService } from './service/authentication.service';
import { EventService } from './service/event.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {

  eventSubscription: Subscription;
  loginState: LoginState;
  LoginStateEnum = LoginState;
  isForceGetSolutionInfo:boolean = false;

  constructor(private authService:AuthenticationService,
              private eventService:EventService,
              private router: Router,
              private title: Title,
              private activatedRoute: ActivatedRoute,
              private elementRef: ElementRef){
                this.eventSubscription = this.eventService.loginState$.subscribe(newLoginState => {
                  //get solution info when users sign back in
                  //or session expired
                  if((this.loginState == LoginState.SignedOut || this.loginState == LoginState.SessionTimedOut) && newLoginState == LoginState.SignedIn){
                    this.isForceGetSolutionInfo = true;
                  }else{
                    this.isForceGetSolutionInfo = false;
                  }
                  
                  this.loginState = newLoginState;
                  if(this.loginState == LoginState.SessionTimedOut || this.loginState == LoginState.SignedOut){
                    this.title.setTitle('Sign in');
                  }else{
                    this.title.setTitle(this.getActivatedRouteURLTitle(this.activatedRoute.root));
                  }
                });
              }
  
  ngOnInit(): void {
    this.elementRef.nativeElement.removeAttribute("ng-version"); //remove angular version from index.html

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.title.setTitle(this.getActivatedRouteURLTitle(this.activatedRoute.root));
      });

    if(this.authService.isLoggedIn()){
      this.loginState = LoginState.SignedIn;
    }else if(this.loginState){
      this.loginState = LoginState.SessionTimedOut;
    }else {
      this.loginState = LoginState.Welcome;
      this.router.navigate(['login']);
    }
  }

  ngOnDestroy() {
    this.eventSubscription.unsubscribe();
  }

  getActivatedRouteURLTitle(route: ActivatedRoute, title:string = ''): string{
    const children: ActivatedRoute[] = route.children;

    if(children.length == 0){
      return title;
    }

    for (const child of children){
      const title = child.snapshot.data['pageTitle'];

      return this.getActivatedRouteURLTitle(child, title);
    }
  }
}